import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useState } from "react";
import { bus } from '../events/EventBus';
import { Events } from '../events/Events';
import Alert from '@material-ui/lab/Alert';
import { IconButton, Collapse } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'fixed',
      left: '50%',
      transform: 'translate(-50%, 0)',
      minWidth: 300,
      maxWidth: 800,
      zIndex: 99998
    },
    alert: {
      "& .MuiAlert-message": {
        textAlign: 'center',
        width: '100%',
      },
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    }
  })
)

export interface AlertMessage {
  message?: string,
  severity?: "error" | "warning" | "info" | "success",
  duration?: number
}

let AnimatedAlert = () => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showClose, setShowClose] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [severity, setSeverity] = useState<"error" | "warning" | "info" | "success" | undefined>();
  const [messageAnimationTimer, setMessageAnimationTimer] = useState<ReturnType<typeof setTimeout>>();

  let onAlertEvent = (event: AlertMessage) => {
    clearTimeout(messageAnimationTimer);

    setMessage(event.message || "");
    setSeverity(event.severity);
    setShowClose((typeof event.duration === 'undefined' || event.duration === 0));
    setIsOpen(true);
    if(event.duration) {
      //Wait [duration] milliseconds, then turn it back off
      setMessageAnimationTimer(setTimeout(() => {
        setIsOpen(false);
      }, event.duration));
    }
  }

  bus.once(Events.onAlert, onAlertEvent);

  return (
    <div className = {classes.root}>
      <Collapse in={isOpen}>
        <Alert
          className = { classes.alert }
          severity = { severity }
          variant = "filled"
          action={showClose &&
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }>
          { message }
        </Alert>
      </Collapse>
    </div>
  )
}
export default AnimatedAlert;